import React, { useState, createRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";
import Auth_brand from "./Auth_brand";

const Create_password = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const [userState, setUserState] = useState({ full_name: "" });
  const [state, setState] = React.useState({
    email: location.state.email,
    password: "",
  });

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });
  const newPasswordCreate = (event) => {
    // event.preventDefault();
    if (state.email != "" && state.password != "") {
      let full_api = config.apiUrl + `/user/create_new_password`;
      // let fullOtp = state.otp1+""+state.otp2+""+state.otp3+""+state.otp4+""+state.otp5+""+state.otp6
      let sendData = { email: state.email, password: state.password };

      // console.log(sendData);
      axios
        .post(full_api, sendData, { headers: config.headers })
        .then((res) => {
          if (res.data.status == true) {
            localStorage.setItem(
              "ship_rocket_user",
              JSON.stringify(res.data.output)
            );
            setUserState({ full_name: res.data.output.full_name });
            config.UserId = res.data.output.customer_id;
            // let sendState = { email:state.email};
            Toast.fire({
              background: "#3659cd",
              type: "success",
              title: res.data.message,
              color: "white",
            });
            setTimeout(() => {
              window.location.replace("/index");
            }, 2000);
          } else {
            Toast.fire({
              background: "#a61c09",
              type: "unsuccess",
              title: res.data.message,
              color: "white",
            });
          }
        })
        .catch((e) => {});
    }
  };
  const handleChangeBroker = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/js/elite.js?v=27";
    script.async = false;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
  return (
    <div>
      <section class="auth-page">
        <div class="auth-form-panel">
          <div class="auth-form-wrap">
            <header>
              <a href="/login" class="auth-logo" aria-label="KalpCargo home">
                <span class="auth-logo-mark">K</span>
                <span class="auth-logo-name">KalpCargo</span>
              </a>

              <div class="auth-heading">
                <h1 class="auth-title">Create a new password</h1>
                <p class="auth-subtitle">
                  Your identity is verified. Set a strong new password to finish
                  resetting your account.
                </p>
              </div>
            </header>

            <form
              onSubmit={(e) => {
                e.preventDefault(); // Prevent the default form submission behavior
                newPasswordCreate(); // Call your login function
              }}
              class="auth-form"
            >
              <div class="auth-field">
                <label class="form-label" for="password">
                  New password
                </label>
                <div class="auth-password">
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    name="password"
                    onChange={(e) => handleChangeBroker(e)}
                    placeholder="Enter new password"
                    autocomplete="new-password"
                    minlength="8"
                    required
                  />
                  <button
                    type="button"
                    class="auth-eye"
                    data-target="password"
                    aria-label="Show password"
                    aria-pressed="false"
                  >
                    <i class="bi bi-eye"></i>
                  </button>
                </div>
              </div>

              {/* <div class="auth-field">
                <label class="form-label" for="password_confirm">
                  Confirm password
                </label>
                <div class="auth-password">
                  <input
                    type="password"
                    class="form-control"
                    id="password_confirm"
                    name="password_confirm"
                    placeholder="Re-enter new password"
                    autocomplete="new-password"
                    minlength="8"
                    required
                  />
                  <button
                    type="button"
                    class="auth-eye"
                    data-target="password_confirm"
                    aria-label="Show password"
                    aria-pressed="false"
                  >
                    <i class="bi bi-eye"></i>
                  </button>
                </div>
              </div> */}

              <button type="submit" class="btn btn-primary auth-submit">
                <span class="auth-spinner" aria-hidden="true"></span>
                <span class="auth-submit-label">Update Password</span>
                <i class="bi bi-arrow-right"></i>
              </button>
            </form>

            <p class="auth-signup">
              <a href="/login">Back to login</a>
            </p>
          </div>
        </div>
        <Auth_brand />
      </section>
    </div>
  );
};

export default Create_password;
